import { DEFAULT_API_VERSION } from "../api/ApiService";
import { ClientDeviceType, UserAgent } from "../model";

export const isTouchDevice = () => {
  return ("ontouchstart" in window || navigator.maxTouchPoints > 0) && !isWebOS();
};

export const isPhone = () => {
  return (
    Math.min(window.innerWidth, window.innerHeight) < 500 &&
    isTouchDevice() /* || process.env.NODE_ENV == "development"*/
  );
};
export const is_iOS = () => {
  return /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent) && isTouchDevice();
};

export const is_Mac = () => {
  return /Macintosh/i.test(navigator.userAgent);
};

export const isSmartTV = () => {
  return /Smart-TV|SmartTV|Color|STB|STV-IPTV/i.test(navigator.userAgent);
};

export const isTV = () => {
  return isSmartTV() || isWebOS() || isTizen();
};

export const isWebOS = () => {
  if (navigator.userAgent) {
    const ua = navigator.userAgent.toLowerCase();
    return (
      /webos|web0s/i.test(ua) ||
      (ua.indexOf("smarttv") !== -1 && ua.indexOf("colt") !== -1)
    );
  }
  return false;
};

export const isTizen = () => {
  if ("tizen" in window) {
    return true;
  } else if (navigator.userAgent) {
    return navigator.userAgent.toLowerCase().indexOf("tizen") !== -1;
  } else {
    return false;
  }
};

export const isVidaa = () => {
  if (navigator.userAgent) {
    return /(hisense|vidaa)/i.test(navigator.userAgent);
  } else {
    return false;
  }
};
export const configureUserAgent: () => UserAgent = () => {
  let deviceType: "DESKTOP" | "MOBILE" | "TABLET" | "TV" = "DESKTOP";
  let client: ClientDeviceType = ClientDeviceType.DESKTOP;
  if (isTV()) {
    deviceType = "TV";
    client = ClientDeviceType.TV;
  } else if (isPhone()) {
    deviceType = "MOBILE";
    client = ClientDeviceType.PHONE;
  } else if (isTouchDevice() && !matchMedia("(pointer:fine)").matches) {
    deviceType = "TABLET";
    client = ClientDeviceType.TABLET;
  }
  const platform =
    (navigator as any)?.userAgentData?.platform || navigator?.platform || "unknown";
  const idx = platform.indexOf(" ");
  let os = idx === -1 ? platform : platform.substring(0, idx);
  if (is_iOS()) {
    os = "iOS";
  } else if (os === "MacIntel") {
    os = "Mac";
  } else if (isVidaa()) {
    os = "Vidaa";
  } else if (isWebOS()) {
    os = "Webos";
  } else if (isTizen()) {
    os = "Tizen";
  }
  return {
    deviceType,
    os: os as "Android",
    client,
    apiVersion: DEFAULT_API_VERSION,
    clientVersion: "1.0.0",
  };
};
